import { Field, FieldProps as FormikFieldProps } from 'formik'

import Toggle from 'components/Input/Toggle'
import { FieldProps } from '../types'
import { ToggleFieldWrapper } from './styles'

interface ToggleProps extends FormikFieldProps {
  disabled?: boolean
  bgColor?: string
  borderColor?: string
  label?: string
  inputId?: string
}

function ToggleDrawer({
  field,
  disabled,
  label,
  inputId,
  ...rest
}: ToggleProps) {
  return (
    <ToggleFieldWrapper>
      <Toggle
        {...field}
        bgColor={rest.bgColor}
        borderColor={rest.borderColor}
        disabled={disabled}
        checked={field.value}
        label={label}
        inputId={inputId}
      />
    </ToggleFieldWrapper>
  )
}

function ToggleField(props: FieldProps) {
  return <Field component={ToggleDrawer} {...props} />
}

export default ToggleField
